import "./bootstrap.ts";
import Swiper from "swiper";
new Swiper('#main_swiper', {
    autoplay: {
        delay: 2000,
    },
    effect: "fade",
    loop: true,
    speed: 2000,
    pagination: {
        el: '.swiper-pagination',
    },
});
new Swiper('.swiper_bnrs', {
    autoplay: {
        delay: 2500,
    },
    direction: 'horizontal',
    effect: 'slide',
    slidesPerView: 1,
    loop: true,
    pagination: {
        el: '.bnr-pagination',
    },
    navigation: {
        nextEl: '.swiper_arrow_next',
        prevEl: '.swiper_arrow_prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        769: {
            direction: 'vertical',
            slidesPerView: 2,
        }
    }
});
